/**
 * The about page's one interactive thing.
 *
 * Only the region map: no body, no upload, no viewer. The claim on that page is
 * "we measured this", and the map is what measuring produced — so it earns a
 * picture, and the picture costs ~6 KB rather than the 627 KB three.js would.
 *
 * Deliberately not `src/home/index.ts`: that coordinator wires a garment
 * toggle, a drop zone and a body pane that do not exist here, and reusing it
 * would mean guarding every one of them.
 */
import { createRegionMap } from "../home/region-map";

const slot = document.querySelector("[data-about-map]") as HTMLElement | null;
if (slot) slot.replaceChildren(createRegionMap().el);
